import Header from './Headers';
import Config from '../config/config';
import Const from '../util/Constants';

class FacebookV2API {
  // Get Facebook Config - Facebook env variables - can store them in client as well, but on server its more secured?
  /**
   * returns Facebook App id 
   * and Facebook api version 
   */
  static getConfig = (success, failure) => {
    fetch(Config.app.link + 'api/facebook/config', new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("getConfig error:", err);
        failure(err);
      });
  };

  // Store Access Token (First time connection)
  static storeToken = (data, success, failure) => {
    fetch(Config.app.link + 'api/facebook/store-token', new Header('POST', data))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("storeToken error:", err);
        failure(err);
      });
  };

  // Refresh Token
  static refreshToken = (success, failure) => {
    fetch(Config.app.link + 'api/facebook/refresh-token', new Header('POST'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("refreshToken error:", err);
        failure(err);
      });
  };

  // Disconnect Facebook
  static disconnect = (integrationId, success, failure) => {
    const url = integrationId 
      ? Config.app.link + `api/facebook/disconnect/${integrationId}`
      : Config.app.link + 'api/facebook/disconnect';
    
    fetch(url, new Header('POST'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("disconnect error:", err);
        failure(err);
      });
  };

  // Add method to list all connected accounts
  static listAccounts = (success, failure) => {
    fetch(Config.app.link + 'api/facebook/connection-status', new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("listAccounts error:", err);
        failure(err);
      });
  };

  static fetchPages = (integrationId, success, failure) => {
    fetch(Config.app.link + `api/facebook/pages/${integrationId}`, new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("updateFieldMapping error:", err);
        failure(err);
      });
  };

  // Fetch Forms for a specific page
  static fetchForms = (integrationId, pageId, success, failure) => {
    fetch(Config.app.link + `api/facebook/forms`, new Header('POST', { integration_id: integrationId, page_id: pageId }))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("fetchForms error:", err);
        failure(err);
      });
  };

  // Fetch Questions (Fields) for a specific form
  static getFormFields = (integrationId, pageId, formId, success, failure) => {
    fetch(Config.app.link + `api/facebook/form-fields`, new Header('POST', { integration_id: integrationId, page_id: pageId, form_id: formId }))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("getFormFields error:", err);
        failure(err);
      });
  };

  // Save the mapping configuration
  static saveMapping = (api, success, failure) => {
    fetch(Config.app.link + `api/facebook/mapping/save`, new Header('POST', api))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("saveMapping error:", err);
        failure(err);
      });
  };

  static getMapping = (id, success, failure) => {
    fetch(Config.app.link + `api/facebook/mapping/` + id, new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("saveMapping error:", err);
        failure(err);
      });
  }

  static backfillLeads = (payload, success, failure) => {
    fetch(Config.app.link + `api/facebook/backfill/leads`, new Header('POST', payload))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("backfillLeads error:", err);
        failure(err);
      });
  };

  static backfillRun = (payload, success, failure) => {
    fetch(Config.app.link + `api/facebook/backfill/run`, new Header('POST', payload))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => {
        console.error("backfillRun error:", err);
        failure(err);
      });
  };
}

export default FacebookV2API;